module.exports = ".login {\r\n    margin: 0 25%;\r\n}\r\n\r\n.login form {\r\n    padding: 20px;\r\n    background-color: #e8f1f2;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main